// extracted by mini-css-extract-plugin
export default {"btn":"EditorTabList_btn__tSPIV","dark":"EditorTabList_dark__FMsu2","TabsList":"EditorTabList_TabsList__jgTsv"};